import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import styled, { keyframes } from 'styled-components'

import { breakpoints, colors } from '@/styles'

import Logo1 from './logos/Logo-1.png'
import Logo2 from './logos/Logo-2.png'
import Logo3 from './logos/Logo-3.png'
import Logo4 from './logos/Logo-4.png'
import Logo5 from './logos/Logo-5.png'
import Logo6 from './logos/Logo-6.png'
import Logo7 from './logos/Logo-7.png'
import Logo8 from './logos/Logo-8.png'
import Logo9 from './logos/Logo-9.png'
import Logo10 from './logos/Logo-10.png'
import Logo11 from './logos/Logo-11.png'
import Logo12 from './logos/Logo-12.png'
import Logo13 from './logos/Logo-13.png'
import Logo14 from './logos/Logo-14.png'
import Logo15 from './logos/Logo-15.png'
import Logo16 from './logos/Logo-16.png'

const logoScroll = keyframes`
  0% { 
    transform: translateX(0%);
  }
  100% {      
    transform: translateX(-100%);
  }
`

const OuterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fafafa;
  padding: 60px 0px 40px 0;
`

const Heading = styled.p`
  text-align: center;
  color: ${colors.grey24};
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  margin: 0 0 20px 0;

  @media (max-width: ${breakpoints.phoneMax}) {
    padding: 0 24px;
  }
`

const WrapperOverflow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  overflow: hidden;
`

const LogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: none;
  animation: ${logoScroll} 90s linear infinite;

  > span {
    margin: 0 32px !important;
  }
`

const LogoSection = () => {
  const { t } = useTranslation()
  return (
    <OuterWrapper>
      <Heading>
        {t('landlords:Trusted by 10,000+ landlords and Property Managers')}
      </Heading>
      <WrapperOverflow>
        <LogoWrapper>
          <Image src={Logo1} alt="logo" width={132} height={96} priority />
          <Image src={Logo2} alt="logo" width={132} height={96} priority />
          <Image src={Logo3} alt="logo" width={132} height={96} priority />
          <Image src={Logo4} alt="logo" width={132} height={96} priority />
          <Image src={Logo5} alt="logo" width={132} height={96} priority />
          <Image src={Logo6} alt="logo" width={132} height={96} priority />
          <Image
            src={Logo7}
            alt="logo"
            width={132}
            height={96}
            objectFit="cover"
            priority
          />
          <Image src={Logo8} alt="logo" width={132} height={96} priority />
          <Image src={Logo9} alt="logo" width={132} height={96} priority />
          <Image src={Logo10} alt="logo" width={132} height={96} priority />
          <Image src={Logo11} alt="logo" width={132} height={96} priority />
          <Image src={Logo12} alt="logo" width={132} height={96} priority />
          <Image src={Logo13} alt="logo" width={132} height={96} priority />
          <Image src={Logo14} alt="logo" width={132} height={96} priority />
          <Image src={Logo15} alt="logo" width={132} height={96} priority />
          <Image src={Logo16} alt="logo" width={132} height={96} priority />
        </LogoWrapper>
        <LogoWrapper>
          <Image src={Logo1} alt="logo" width={132} height={96} priority />
          <Image src={Logo2} alt="logo" width={132} height={96} priority />
          <Image src={Logo3} alt="logo" width={132} height={96} priority />
          <Image src={Logo4} alt="logo" width={132} height={96} priority />
          <Image src={Logo5} alt="logo" width={132} height={96} priority />
          <Image src={Logo6} alt="logo" width={132} height={96} priority />
          <Image
            src={Logo7}
            alt="logo"
            width={132}
            height={96}
            objectFit="cover"
            priority
          />
          <Image src={Logo8} alt="logo" width={132} height={96} priority />
          <Image src={Logo9} alt="logo" width={132} height={96} priority />
          <Image src={Logo10} alt="logo" width={132} height={96} priority />
          <Image src={Logo11} alt="logo" width={132} height={96} priority />
          <Image src={Logo12} alt="logo" width={132} height={96} priority />
          <Image src={Logo13} alt="logo" width={132} height={96} priority />
          <Image src={Logo14} alt="logo" width={132} height={96} priority />
          <Image src={Logo15} alt="logo" width={132} height={96} priority />
          <Image src={Logo16} alt="logo" width={132} height={96} priority />
        </LogoWrapper>
      </WrapperOverflow>
    </OuterWrapper>
  )
}

export default LogoSection
